import { Box, Modal, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const StyledModal = styled(Modal)`
  .MuiBackdrop-root {
    background: linear-gradient(111.58deg, rgba(69, 90, 100, 0.5) 0%, rgba(139, 182, 202, 0.5) 100.36%);
    backdrop-filter: blur(3px);
  }
`;

export const ModalBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: 23px;
  padding: 1.5rem;
  min-width: 654px;
  width: auto;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 64px);
  overflow-y: auto;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    min-width: unset;
    width: calc(100vw - 32px);
    padding: 1rem;
    border-radius: 16px;
  }

  ${({ theme }) => theme.breakpoints.between('sm', 'md')} {
    min-width: 500px;
    max-width: 600px;
  }
`;

export const StyledCloseIcon = styled(CloseIcon)`
  cursor: pointer;
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  z-index: 1;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const WarningIconCircle = styled(Box)`
  background: ${({ theme }) => `${theme.palette.error.main}4D`};
  color: ${({ theme }) => theme.palette.error.dark};
  padding: 10px;
  border-radius: 100%;
  height: 44px;
`;
